import { RootStateOrAny, useSelector } from 'react-redux';
import { AccountResource } from 'util/resources/Account';

export const useAccount = (): {
  currentAccount: AccountResource;
  authenticated: boolean;
  loaded: boolean;
  loading: boolean;
} => {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  const {
    currentAccount,
    authenticated,
    loaded,
    loading,
  }: {
    currentAccount: AccountResource;
    authenticated: boolean;
    loaded: boolean;
    loading: boolean;
  } = useSelector(
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    ({ account }: RootStateOrAny) => account,
  );

  return {
    currentAccount,
    authenticated,
    loaded,
    loading,
  };
};
